import { Canvas, FabricObject, loadSVGFromString, util } from 'fabric';

type Position = { left: number; top: number };

export const addSvgToCanvas = async (canvas: Canvas, svgText: string, position: Position) => {
  const { objects, options } = await loadSVGFromString(svgText);
  const valid = objects.filter((o): o is FabricObject => o !== null);
  if (valid.length === 0) return;

  const shape = util.groupSVGElements(valid, options);
  shape.set({
    left: position.left,
    top: position.top,
    originX: 'center',
    originY: 'center'
  });

  canvas.add(shape);
  canvas.setActiveObject(shape);
  canvas.requestRenderAll();
};
